import React, { useEffect } from 'react';
import styles from './AddOrEditSectionModal.module.scss';
import { ConfirmModal, Input } from 'tt-ui-lib/core';

const AddOrEditSectionModal = ({
  openSectionModal,
  setOpenSectionModal,
  activeSection,
  loadingAction,
  handleSubmit,
  setActiveSection,
  error,
  setError,
}) => {
  const [sectionName, setSectionName] = React.useState('');

  useEffect(() => {
    if (activeSection && activeSection.name) {
      setSectionName(activeSection.name);
    } else {
      setSectionName('');
    }
  }, [activeSection]);

  useEffect(() => {
    if (sectionName.length > 50) {
      setError(true);
    } else {
      setError(false);
    }
  }, [sectionName]);

  return (
    <ConfirmModal
      open={openSectionModal}
      title={`${activeSection?.id ? 'Edit' : 'Add new'} section`}
      loading={loadingAction}
      subTitle={
        <div className={styles.modalEditInputWrapper}>
          <Input
            label="Title"
            value={sectionName}
            // helperText={error && 'Title exceeds the maximum allowed length of 50 characters.'}
            onChange={(e) => setSectionName(e.target.value)}
          />
        </div>
      }
      onConfirm={() => {
        handleSubmit(sectionName);
        if (!error) {
          setSectionName('');
        }
      }}
      onClose={() => {
        setOpenSectionModal(false);
        setActiveSection(null);
        setSectionName('');
      }}
      okText="Save"
    />
  );
};

export default AddOrEditSectionModal;
